<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_first_contact_intro')
}

const isOnDiplomacySection = computed(() => {
  return route.path.startsWith('/diplomacy/overview')
})

const goToDiplomacy = () => {
  router.push('/diplomacy/overview')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.firstContact.intro.metCivilization') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.firstContact.intro.goToDiplomacy') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.firstContact.intro.clickDiplomacyDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.firstContact.intro.clickDiplomacyMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnDiplomacySection" @click="goToDiplomacy" class="mr-2">
        {{ t('tutorial.firstContact.intro.goToDiplomacyBtn') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.firstContact.intro.done') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>